import { Injectable } from '@angular/core';
import { ToasterService } from '@purespectrum1/ui/toaster-service';
import { notifyMessage } from '../../../../../shared/constants/notify-message';
import { GroupTemplateSupplier } from '../../../../../shared/services/manage-suppliers-service/manage-suppliers.interface';

@Injectable({
  providedIn: 'root',
})
export class SupplierGroupValidatorService {
  constructor(private _toastr: ToasterService) {}

  public validateIndividualAllocationInGroup(
    suppliers: GroupTemplateSupplier[],
    isCustomAllocation: boolean
  ) {
    if (!isCustomAllocation) {
      return true;
    }
    const limit = 100;
    const hasAboveLimitAlloc = suppliers.find(
      (supplier) => (Number(supplier.allocation) || 0) > limit
    );
    if (hasAboveLimitAlloc) {
      this._toastr.error(
        notifyMessage.errorMessage.SUPPLIER_GROUP
          .INDIVIDUAL_ALLOCATION_OUT_OF_LIMIT
      );
      return false;
    }

    const isZero = suppliers.find((supplier) => {
      const alloc = Number(supplier.allocation);
      return isNaN(alloc) || alloc <= 0;
    });

    if (isZero) {
      this._toastr.error(
        notifyMessage.errorMessage.SUPPLIER_GROUP.INDIVIDUAL_ALLOCATION_ZERO
      );
      return false;
    }
    return true;
  }
}
